import React, { useState } from 'react'
import { Collapse, Icon } from 'antd'
import { FormSubmitButton, FormatText, MasterDetailForm, Widget, usePromise, Row, FormNumber } from '@digital/ui'
import { GetFaturamentoDireto, UpdateFaturaMentoDireto} from '@app/api/configuracoes'
import { hasPermission } from '@app/helpers/permissions'

const { Panel } = Collapse

const ConfiguracaoFaturamentoDireto = () => {
    const [update, setUpdate] = useState(false)
    const [dados] = usePromise(async () => await GetFaturamentoDireto(), [update], {})

    const onUpdate = (values: any) => {
        UpdateFaturaMentoDireto(values).then(data => {
            if (data.valid) {
                setUpdate(!update)
            }
        })
    }

    return (
        <>
            <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="configuracoesFaturamentoDireto" header="Parâmetros Faturamento Direto">
                    <MasterDetailForm
                        initialValues={dados}
                        onSubmit={onUpdate}
                    >
                        <Widget
                            actions={[
                                hasPermission(['CONFIGURACAO_FATURAMENTODIRETO_EDITAR']) && (
                                    <FormSubmitButton noIcon type="primary">
                                        <FormatText id="ui.commons.save" uppercase />
                                    </FormSubmitButton>
                                )
                            ]}
                        >
                            <Row>
                                <FormNumber
                                    label="Prazo Valor Máximo Percentual"
                                    name="faturamentoDiretoValorMaximoPercentual"
                                    span={2}
                                    min={1}
                                    maxLength={4}
                                />
                            </Row>   
                            
                            <Row>
                                <FormNumber
                                    label="Prazo Mínimo (meses)"
                                    name="faturamentoDiretoPrazoMinimo"
                                    span={2}
                                    min={1}
                                    maxLength={4}
                                />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Panel>
            </Collapse>
        </>
    )
}

export default ConfiguracaoFaturamentoDireto